import { EmbedView } from '../../../components/EmbedView';
import { SingleQueryResults } from '../../../components/QueryResults/SingleQueryResults';
import { useActiveWorkspace } from '../../../hooks/useActiveWorkspace';

/**
 * Historic Royalties "Past Statements" tab. Embeds the historical (past) payment statements
 * view — the content previously rendered by the Historical Payments page.
 */
export const RoyaltiesStatements = () => {
  const [, activeWorkspaceQuery] = useActiveWorkspace();

  return (
    <SingleQueryResults query={activeWorkspaceQuery}>
      {(workspace) => (
        <EmbedView
          embedType="payments"
          loadingMessage="Loading your payment statements, please stand by..."
          resourceId={workspace._id}
        />
      )}
    </SingleQueryResults>
  );
};
